import { render, staticRenderFns } from "./ScoreDetail.vue?vue&type=template&id=3868e438&"
import script from "./ScoreDetail.vue?vue&type=script&lang=js&"
export * from "./ScoreDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports